export async function GetFooterContent(): Promise<any> {
  try {
    const res = await fetch('/api/sitecore/NowNavigationAsync/GetFooterContent');
    const contentType = res.headers.get('content-type');
    if (contentType && contentType.indexOf('application/json') !== -1) {
      const resJson = await res.json();
      return resJson;
    } else {
      console.error('GetFooterContent');
      console.error(res.text());
    }
  } catch (err: any) {
    console.error('GetFooterContent');
    console.error(err.message);
  }
  return [];
}
